export default __webpack_public_path__ + "static/media/immigration.7a1ad24a.png";